import { getServerSyncedTime } from '../../../utils/TimeUtils';
import { useFullTrack, useTrackPendingPracticalExercises } from '../../tracks';
import ExamIncompleteExercisesScreen from './ExamIncompleteExercisesScreen';
import ExamCongratulationsScreen from './ExamCongratulationsScreen';
import ExamCertificationExpiredScreen from './ExamCertificationExpiredScreen';
import ExamAttemptExpiredScreen from './ExamAttemptExpiredScreen';
import ExamAttemptExpiredIncompleteExercisesScreen from './ExamAttemptExpiredIncompleteExercisesScreen';
import ExamAwardNotGeneratedScreen from './ExamAwardNotGeneratedScreen';
import ExamAttemptFailedScreen from './ExamAttemptFailedScreen';
import { useExamAttemptExpiry, useTrackAwardExpiry, useMostRecentExamAttempt } from '../examsQueries';
import ExamLayout from './ExamLayout';
import ExamLoadingScreen from './ExamLoadingScreen';
import { jsx as _jsx } from "react/jsx-runtime";
const ExamFinishedScreen = ({
  award,
  trackId,
  language,
  certificationAwardedInDifferentLanguage
}) => {
  const {
    pendingPracticalExercises,
    pendingPracticalExercisesLoading
  } = useTrackPendingPracticalExercises(trackId.toString(), language);
  const {
    track,
    trackLoading
  } = useFullTrack(trackId, language);
  const {
    mostRecentExamAttempt,
    mostRecentExamAttemptLoading
  } = useMostRecentExamAttempt(Number(trackId), language);
  const {
    isExpired: isAwardExpired,
    examExpiryLoading
  } = useTrackAwardExpiry(Number(trackId));
  const {
    isAttemptExpired,
    attemptExpiryLoading
  } = useExamAttemptExpiry(Number(trackId), language);
  const examIsRecent = mostRecentExamAttempt ? getServerSyncedTime() - mostRecentExamAttempt.attemptFinishTime < 24 * 60 * 60 * 1000 : false;
  const probablyHasCert = track && (track.certification || !!track.exam) && mostRecentExamAttempt && mostRecentExamAttempt.passed && pendingPracticalExercises && !pendingPracticalExercises.length;
  const attemptFinished = mostRecentExamAttempt && mostRecentExamAttempt.finished;
  const certificationExpired = !examIsRecent && isAwardExpired;
  const practicalExercisesFinished = pendingPracticalExercises && !pendingPracticalExercises.length;
  const awardNotYetLoaded = !award && probablyHasCert && examIsRecent;
  const passed = mostRecentExamAttempt && mostRecentExamAttempt.passed;
  const isLoadingCombined = pendingPracticalExercisesLoading || trackLoading || mostRecentExamAttemptLoading || examExpiryLoading || attemptExpiryLoading;
  if (isLoadingCombined) {
    return /*#__PURE__*/_jsx(ExamLayout, {
      children: /*#__PURE__*/_jsx(ExamLoadingScreen, {})
    });
  }
  if (passed && attemptFinished && !isAttemptExpired && !isAwardExpired && !practicalExercisesFinished) {
    return /*#__PURE__*/_jsx(ExamIncompleteExercisesScreen, {
      language: language,
      trackId: trackId
    });
  }
  if (passed && practicalExercisesFinished && !certificationExpired && (awardNotYetLoaded || award)) {
    return /*#__PURE__*/_jsx(ExamCongratulationsScreen, {
      certificationAwardedInDifferentLanguage: certificationAwardedInDifferentLanguage,
      language: language,
      trackId: trackId
    });
  }
  if (passed && certificationExpired && practicalExercisesFinished) {
    return /*#__PURE__*/_jsx(ExamCertificationExpiredScreen, {
      language: language,
      trackId: trackId
    });
  }
  if (passed && isAttemptExpired && practicalExercisesFinished) {
    return /*#__PURE__*/_jsx(ExamAttemptExpiredScreen, {
      language: language,
      trackId: trackId
    });
  }
  if (passed && isAttemptExpired && !practicalExercisesFinished) {
    return /*#__PURE__*/_jsx(ExamAttemptExpiredIncompleteExercisesScreen, {
      language: language,
      trackId: trackId
    });
  }

  // Award failed to generate
  if (passed && !award) {
    return /*#__PURE__*/_jsx(ExamAwardNotGeneratedScreen, {
      language: language,
      trackId: trackId
    });
  }
  return /*#__PURE__*/_jsx(ExamAttemptFailedScreen, {
    language: language,
    trackId: trackId
  });
};
export default ExamFinishedScreen;